import { render } from "./GroupSelectionListView.vue?vue&type=template&id=f87904ae&scoped=true&ts=true"
import script from "./GroupSelectionListView.vue?vue&type=script&lang=ts"
export * from "./GroupSelectionListView.vue?vue&type=script&lang=ts"

import "./GroupSelectionListView.vue?vue&type=style&index=0&id=f87904ae&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87904ae"]])

export default __exports__